	
	//将阿拉伯数字转换为大写数字
	export function rp (n) {
				var cnum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
	            var s = '';
	            n = '' + n; // 数字转为字符串
	            for (var i = 0; i < n.length; i++) {
	                s += cnum[parseInt(n.charAt(i))];
	            }
	            if (s.length == 2) { // 两位数的时候
	                // 如果个位数是0的时候，0改成十
	                if (s.charAt(1) == cnum[0]) {
	                    s = s.charAt(0) + cnum[10];
	                    // 如果是一十改成十
	                    if (s == cnum[1] + cnum[10]) {
	                        s = cnum[10]
	                    }
	                } else if (s.charAt(0) == cnum[1]) {
	                    // 如果十位数是一的话改成十
	                    s = cnum[10] + s.charAt(1);
	                }else if (s.charAt(0) == cnum[2]) {
	                    // 如果十位数是二的话改成十二
	                    s = cnum[2] + cnum[10] + s.charAt(1);
	                }else if (s.charAt(0) == cnum[3]) {
	                    s = cnum[3] + cnum[10] + s.charAt(1);
	                }else if (s.charAt(0) == cnum[4]) {
	                    s = cnum[4] + cnum[10] + s.charAt(1);
	                }else if (s.charAt(0) == cnum[5]) {
	                    s = cnum[5] + cnum[10] + s.charAt(1);
	                }else if (s.charAt(0) == cnum[6]) {
	                    s = cnum[6] + cnum[10] + s.charAt(1);
	                }else if (s.charAt(0) == cnum[7]) {
	                    s = cnum[7] + cnum[10] + s.charAt(1);
	                }else if (s.charAt(0) == cnum[8]) {
	                    s = cnum[8] + cnum[10] + s.charAt(1);
	                }else if (s.charAt(0) == cnum[9]) {
	                    s = cnum[9] + cnum[10] + s.charAt(1);
	                }else if (s.charAt(0) == cnum[10]) {
	                    s = cnum[10] + cnum[10] + s.charAt(1);
	                }
	
	            }
	            return s;
	}

	
	/**
	* 将 yyyy-MM-dd h:m:s 格式的时间转为时间戳
	* time -> YYYY-MM-DD hh:mm:ss 格式的字符串
	*/
    export function formDate(time) {
		const thisTime = time.replace(/ /g, '/')
		var nowTime = new Date(thisTime)
		nowTime = nowTime.getTime()
		return nowTime
	}
    
	//获取前后连续n天的时间：返回时间格式yyyy-MM-dd
	export function GetDateStr(AddDayCount) { 
		var dd = new Date();
		dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
		var y = dd.getFullYear(); 
		var m = (dd.getMonth()+1)<10?"0"+(dd.getMonth()+1):(dd.getMonth()+1);//获取当前月份的日期，不足10补0
		var d = dd.getDate()<10?"0"+dd.getDate():dd.getDate();//获取当前几号，不足10补0
		return y+"-"+m+"-"+d; 
	}

	//返回时间段内时间间隔的数组
	//startTime开始时间,endTime结束时间(时间戳),interval间隔时间(分钟)
	export function getTimeArr(startTime,endTime,interval) {
      let startDate = startTime;
      let endDate = endTime;
      const space = interval * 60 * 1000;
      let mod = endDate - startDate;
      let dateArray = [];
      while (mod > space) {
        let d = new Date();
        d.setTime(startDate + space);
        dateArray.push(d);
        mod = mod - space;
        startDate = startDate + space;
      }
      dateArray.unshift(new Date(startTime));

      dateArray.push(new Date(endTime));

      let a = dateArray.map(item => {
		if(item.getHours()<10&&item.getMinutes()<10){
			item = '0'+item.getHours() + ":" +'0'+item.getMinutes();
		}else if(item.getHours()>=10&&item.getMinutes()<10){
			 item = item.getHours() + ":" +'0'+item.getMinutes();
		}else if(item.getHours()<10&&item.getMinutes()>=10){
			 item = '0'+item.getHours() + ":" +item.getMinutes();
		}else
		{
			item = item.getHours() + ":" + item.getMinutes();}
        return item;
      });
	  return a;
    }
	
	// 时间戳转换日期格式方法
	export function formatDate(value,type) {
	                if (value == null) {
	                    return '';
	                } else {
	                    let date = new Date(value);
	                    let y = date.getFullYear();// 年
	                    let MM = date.getMonth() + 1;// 月
	                    MM = MM < 10 ? ('0' + MM) : MM;
	                    let d = date.getDate();// 日
	                    d = d < 10 ? ('0' + d) : d;
	                    let h = date.getHours();// 时
	                    h = h < 10 ? ('0' + h) : h;
	                    let m = date.getMinutes();// 分
	                    m = m < 10 ? ('0' + m) : m;
	                    let s = date.getSeconds();// 秒
	                    s = s < 10 ? ('0' + s) : s;
						switch(type){
							case 'YY-MM-DD':
								return y + '-' + MM + '-' + d;
							case 'YY-MM-DD HH-MM-SS':
								return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
							default:
								return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
						}
	                }
	            }
	
	/**
	 * [dateAddDays 从某个日期增加n天后的日期]
	 * @param  {[string]} dateStr  [日期字符串]
	 * @param  {[int]} dayCount [增加的天数]
	 * @return {[string]}[增加n天后的日期字符串]
	 */
	export function dateAddDays(dateStr,dayCount) {
	    var tempDate=new Date(dateStr.replace(/-/g,"/"));//把日期字符串转换成日期格式
	    var resultDate=new Date((tempDate/1000+(86400*dayCount))*1000);//增加n天后的日期
		var month=resultDate.getMonth()+1;
		month = month > 9 ? month : ('0' + month)
	    var resultDateStr=resultDate.getFullYear()+"-"+month+"-"+(resultDate.getDate());//将日期转化为字符串格式
	    return resultDateStr;
	}
	
	/**
	* 根据两个日期，判断相差天数
	* @param sDate1 开始日期 如：2016-11-01
	* @param sDate2 结束日期 如：2016-11-02
	* @returns {number} 返回相差天数
	*/
	export function daysBetween(sDate1,sDate2){
		//Date.parse() 解析一个日期时间字符串，并返回1970/1/1 午夜距离该日期时间的毫秒数
		var time1 = Date.parse(new Date(sDate1));
		var time2 = Date.parse(new Date(sDate2));
		var nDays = Math.abs(parseInt((time2 - time1)/1000/3600/24));
		return nDays;
	}
	
	/**获取当前时间时分秒**/
	export function nowtime(){
	  var date = new Date();
	  var sign2 = ":";
	  var year = date.getFullYear() // 年
	  var month = date.getMonth() + 1; // 月
	  var day = date.getDate(); // 日
	  var hour = date.getHours(); // 时
	  var minutes = date.getMinutes(); // 分
	  var seconds = date.getSeconds() //秒
	  var weekArr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'];
	  var week = weekArr[date.getDay()];
	  // 给一位数的数据前面加 “0”
	  if (month >= 1 && month <= 9) {
	    month = "0" + month;
	  }
	  if (day >= 0 && day <= 9) {
	    day = "0" + day;
	  }
	  if (hour >= 0 && hour <= 9) {
	    hour = "0" + hour;
	  }
	  if (minutes >= 0 && minutes <= 9) {
	    minutes = "0" + minutes;
	  }
	  if (seconds >= 0 && seconds <= 9) {
	    seconds = "0" + seconds;
	  }
	  return year + "-" + month + "-" + day + " " + hour + sign2 + minutes + sign2 + seconds;
	}
	
	
	
